import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import "../../../_assets/css/custom.css";
import OwlCarousel from "react-owl-carousel2";
import "react-owl-carousel2/lib/styles.css";
import { postMethod } from "../../../_services/_postMethod";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import CustomerHeader from "./components/header";
import CustomerFooter from "./components/footer";
import CustomerBanner from "./components/banner";
import CustomerCategoryBanner from "./components/category_banner";
import { API_BASE_URL } from "../../../_services/constant";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  Tab,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Slide,
  Tabs,
  TextField,
  Typography,
  Box,
  makeStyles,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Button,
  CardActions,
  DialogActions,
  Snackbar,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Input, Label, FormGroup } from "reactstrap";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    height: 224,
  },
  tabs: {
    borderRight: 'none',
    width: 175,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#000",
    backgroundColor: "#fff",
  },
  productGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
    gap: '16px',
    padding: '16px 0',
    '@media (max-width: 600px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '8px',
      padding: '8px 0',
    },
  },
  productCard: {
    borderRadius: '16px',
    background: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 48px rgba(0, 0, 0, 0.12)',
      '& $cardImage': {
        transform: 'scale(1.05)',
      },
      '& $wishlistIcon': {
        opacity: 1,
        transform: 'translateY(0)',
      }
    }
  },
  imageContainer: {
    position: 'relative',
    width: '100%',
    paddingTop: '100%',
    overflow: 'hidden',
    backgroundColor: '#f8f9fa',
  },
  cardImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    transition: 'transform 0.5s ease',
  },
  cardContent: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'space-between',
    '@media (max-width: 600px)': {
      padding: '8px',
    },
  },
  productTitle: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: '2px',
    fontFamily: '"Inter", "Outfit", sans-serif',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textDecoration: 'none',
    '@media (max-width: 600px)': {
      fontSize: '0.8rem',
    },
  },
  productSize: {
    fontSize: '0.85rem',
    color: '#aaa',
    marginBottom: '8px',
  },
  priceContainer: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    flexWrap: 'wrap',
    marginTop: 'auto',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '4px',
    },
  },
  currentPrice: {
    fontSize: '1.1rem',
    fontWeight: 700,
    color: '#000',
  },
  originalPrice: {
    fontSize: '0.9rem',
    color: '#888',
    textDecoration: 'line-through',
  },
  wishlistIcon: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    cursor: 'pointer',
    color: '#ff3366',
    background: 'white',
    borderRadius: '50%',
    zIndex: 10,
    '&.active': {
      opacity: 1,
      transform: 'translateY(0)',
      color: 'red',
    },
    '&:hover': {
      color: 'red',
      transform: 'scale(1.1) translateY(0)',
    }
  },
  badge: {
    position: 'absolute',
    top: '12px',
    left: '12px',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    zIndex: 10,
  },
  badgeNew: {
    top: 'auto',
    bottom: '12px',
    left: 'auto',
    right: '12px',
    backgroundColor: '#000',
    color: '#fff',
  },
  badgeTrial: {
    top: 'auto',
    bottom: '12px',
    left: '12px',
    right: 'auto',
    backgroundColor: '#e6f7ff',
    color: '#0050b3',
    border: '1px solid #91d5ff',
  },
  sidebarContainer: {
    background: '#ffffff',
    borderRadius: '32px',
    padding: '32px 24px',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.04)',
    border: '1px solid #f4f4f4',
    position: 'sticky',
    top: '20px',
  },
  sidebarTitle: {
    fontSize: '1.2rem',
    fontWeight: 700,
    marginBottom: '10px',
    color: '#1a1a1a',
    fontFamily: '"Inter", "Outfit", sans-serif',
  },
  accordionRoot: {
    boxShadow: 'none !important',
    backgroundColor: 'transparent !important',
    border: 'none !important',
    '&:before': {
      display: 'none !important',
    },
    marginBottom: '2px !important',
  },
  accordionSummary: {
    padding: '0 !important',
    minHeight: '28px !important',
    '&.Mui-expanded': {
      minHeight: '28px !important',
    },
    '& .MuiAccordionSummary-content': {
      margin: '2px 0 !important',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '2px 0 !important',
    },
  },
  accordionTitle: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#2b2b2b',
    fontFamily: '"Inter", sans-serif',
  },
  priceSection: {
    padding: '4px 0 10px 0',
  },
  priceTitle: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: '8px',
    fontFamily: '"Inter", sans-serif',
  }
}));

const CustomerProducts = (props) => {
  const classes = useStyles();

  const normalizeColor = (color) => {
    if (!color) return 'transparent';
    const colorMap = {
      'navyblue': 'navy',
      'skyblue': 'skyblue',
      'lightblue': 'lightblue',
      'darkblue': 'darkblue',
      'darkgreen': 'darkgreen',
      'lightgreen': 'lightgreen',
      'darkred': 'darkred',
      'darkpink': 'deeppink',
      'lightpink': 'lightpink',
      'hotpink': 'hotpink',
      'darkgray': 'darkgray',
      'lightgray': 'lightgray',
      'offwhite': '#f5f5f0',
      'darkbrown': '#4a2c0a',
      'lightbrown': '#c68642',
      'babyblue': '#89cff0',
      'babypink': '#f9c1d0',
      'royalblue': 'royalblue',
      'forestgreen': 'forestgreen',
      'olivegreen': 'olivedrab',
      'rosegold': '#b76e79',
    };
    const normalized = color.toLowerCase().replace(/\s+/g, '');
    if (colorMap[normalized]) return colorMap[normalized];
    // Fall back to the second word if multi-word (e.g. "Navy Blue" → "blue")
    const words = color.trim().split(/\s+/);
    if (words.length > 1) return words[1].toLowerCase();
    return normalized;
  };

  const [open, setOpen] = React.useState(false);
  const { register, handleSubmit, errors } = useForm();
  const [isvalid, setValid] = useState(false);
  const [load, setLoad] = useState(false);
  const inputRef = React.createRef(null);
  const [sortOpen, setsortOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [categorys, setCategorys] = useState([]);
  const [category, setCategory] = useState("");
  const [material, setMaterial] = useState("");
  const [orderPrice, setOrderPrice] = useState("desc");
  const [short_filters, setShortFilters] = useState({
    new: false,
    order: "desc",
    trial: false,
  });
  const [genders, setGenders] = useState("");
  const [gender, setGender] = useState("");
  const [metals, setMetals] = useState("");
  const [metal, setMetal] = useState("");
  const [colors, setColors] = useState([]);
  const [colorFilter, setColorFilter] = useState("");
  const [weights, setWeights] = useState([]);
  const [weightFilter, setWeightFilter] = useState("");
  const [priceRange, setPriceRange] = useState({ min: 0, max: 0 });
  const [priceRangeSet, setPriceRangeSet] = useState({ min: 0, max: 0 });
  const [voucherList, setVoucherList] = useState([]);
  const [Tabvalue, setValue] = React.useState(0);
  const [productCount, setProductCount] = React.useState(0);
  const [show, setShow] = useState(false);
  const [sortObj, setSortObj] = useState({
    new: false,
    hightolow: false,
    lowtohigh: false,
    new: false,
    tryathome: false,
    shortingApplied: false
  });

  const applyShorting = () => {
    let shortValue = "";
    if (sortObj.new) {
      shortValue = "new";
    }
    if (sortObj.hightolow) {
      shortValue = "desc";
    }
    if (sortObj.lowtohigh) {
      shortValue = "asc";
    }
    if (sortObj.tryathome) {
      shortValue = "trial";
    }
    setFilter(shortValue);
    setSortObj({ ...sortObj, shortingApplied: true })
    setsortOpen(false);
  }

  const handleModal = () => {
    setOpen(!open);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSortModal = () => {
    setsortOpen(!sortOpen);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const options = {
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 4,
      },
    },
    dots: false,
    autoplay: true,
    // center:true,
    stagePadding: 10,
    margin: 10,
    loop: true,
    nav: true,
  };

  const RedirectToProduct = (product_id) => {
    localStorage.setItem("product_id", product_id);
    window.location.pathname = "customersession/product-view";
  };

  useEffect(() => {
    setLoad(true);
    localStorage.setItem("subcategory_id", 0);
    postMethod("api/session/category_list_customized", {}).then((dataD) => {
      setCategorys(dataD.data || []);
    });
  }, []);

  const getEffectivePrice = (p) => {
    const dp = Number(p.discounted_price);
    return (dp && dp > 0) ? dp : Number(p.price) || 0;
  };

  const applyClientSort = (list, order) => {
    if (!list || !list.length) return list;
    const sorted = [...list];
    if (order === 'asc') sorted.sort((a, b) => getEffectivePrice(a) - getEffectivePrice(b));
    if (order === 'desc') sorted.sort((a, b) => getEffectivePrice(b) - getEffectivePrice(a));
    return sorted;
  };

  const applyClientPriceFilter = (list, min, max) => {
    if (!list || !list.length) return list;
    const maxVal = max > 0 ? max : Infinity;
    return list.filter(p => {
      const ep = getEffectivePrice(p);
      return ep >= min && ep <= maxVal;
    });
  };

  const getCustomisedProduct = () => {
    setLoad(true);
    postMethod("api/session/customized_products", {
      category_id: localStorage.getItem("category_id"),
      subcategory_id: localStorage.getItem("subcategory_id"),
      price_order: "",
      trial: false,
      new: false,
      min_price: 0,
      max_price: 99999999,
      metal: "",
      material: "",
      shop_for: "",
      skip: "0",
    }).then((data) => {
      let rawList = data.data || data || [];

      // Extract all filter option names and values directly from customized_products API
      const extractedMetals = [...new Set(rawList.map(p => p.metal || p.Metal).filter(m => m && String(m).trim()))].map(m => ({ Metal: m, metal: m }));
      const extractedMaterials = [...new Set(rawList.map(p => p.material || p.Material).filter(m => m && String(m).trim()))].map(m => ({ material: m, Material: m }));
      const extractedGenders = [...new Set(rawList.map(p => p.gender || p.shop_for || p.gender_name).filter(g => g && String(g).trim()))].map(g => ({ gender: g }));
      const extractedColors = [...new Set(rawList.map(p => p.color).filter(c => c && String(c).trim()))];
      const extractedWeights = [...new Set(rawList.map(p => p.weight || p.gross_weight || p.net_weight).filter(w => w && String(w).trim()))];

      setMetals(extractedMetals);
      setMaterials(extractedMaterials);
      setGenders(extractedGenders);
      setColors(extractedColors);
      setWeights(extractedWeights);

      const prices = rawList.map(p => getEffectivePrice(p));
      const maxPrice = prices.length ? Math.max(...prices, 0) : 0;
      setPriceRangeSet(prev => (prev.max > 0 ? prev : { min: 0, max: maxPrice }));
      setPriceRange(prev => (prev.max > 0 ? prev : { min: 0, max: maxPrice }));

      let result = rawList;

      // 1. Metal filter (client-side)
      if (metal) {
        result = result.filter(p => {
          const m = p.metal || p.Metal;
          return m && String(m).toLowerCase() === String(metal).toLowerCase();
        });
      }

      // 2. Material filter (client-side)
      if (material) {
        result = result.filter(p => {
          const mat = p.material || p.Material;
          return mat && String(mat).toLowerCase() === String(material).toLowerCase();
        });
      }

      // 3. Gender / Shop For filter (client-side)
      if (gender) {
        result = result.filter(p => {
          const g = p.gender || p.shop_for || p.gender_name;
          return g && String(g).toLowerCase() === String(gender).toLowerCase();
        });
      }

      // 4. Color filter (client-side)
      if (colorFilter) {
        result = result.filter(p => p.color && String(p.color).toLowerCase() === String(colorFilter).toLowerCase());
      }

      // 5. Weight filter (client-side)
      if (weightFilter) {
        result = result.filter(p => {
          const w = String(p.weight || p.gross_weight || p.net_weight || "");
          return w.toLowerCase() === String(weightFilter).toLowerCase();
        });
      }

      // 6. New filter (client-side)
      if (short_filters.new) {
        result = result.filter(p => p.new == "true" || p.new === true);
      }

      // 7. Trial filter (client-side)
      if (short_filters.trial) {
        result = result.filter(p => p.trial == "true" || p.trial === true);
      }

      // 8. Price Range filter (client-side)
      if (priceRange.min > 0 || (priceRange.max > 0 && priceRange.max < maxPrice)) {
        result = applyClientPriceFilter(result, priceRange.min, priceRange.max);
      }

      // 9. Sorting (client-side)
      result = applyClientSort(result, short_filters.order);

      setProducts(result);
      setLoad(false);
    }).catch(() => setLoad(false));
  };

  useEffect(() => {
    getCustomisedProduct();
  }, [material, metal, priceRange, short_filters, gender, colorFilter, weightFilter]);

  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }

  const changeRange = (e) => {
    setPriceRange({ ...priceRange, min: e.min, max: e.max });
  };

  const categorychange = (category_id, subcategory_id) => {
    localStorage.setItem("category_id", category_id);
    localStorage.setItem("subcategory_id", subcategory_id);
    setLoad(true);
    setMaterial("");
    setMetal("");
    setColorFilter("");
    setWeightFilter("");


    postMethod("api/session/customized_products", {
      category_id: category_id,
      subcategory_id: subcategory_id,
      price_order: short_filters.order,
      trial: short_filters.trial,
      new: short_filters.new,
      min_price: 0,
      max_price: 99999999,
      metal: "",
      material: "",
      skip: "0",
    }).then((data) => {
      setProducts(data.data || data || []);

    });

    postMethod("api/session/customized_product_filter", {
      category_id: category_id,
      subcategory_id: subcategory_id
    }).then((dataD) => {
      var data = dataD.data;
      setPriceRangeSet({
        min: 0,
        max: Number(data[0][0].max || 0),
      });

      setPriceRange({
        min: 0,
        max: Number(data[0][0].max || 0),
      });
      setMetals(data[1]);
      setMaterials(data[2]);
      setGenders(data[3]);
      setCategorys(data[4]);

      setTimeout(() => {
        setLoad(false);
      }, 2000);

    });

  };

  const [openWish, setOpenWish] = React.useState(false);

  const handleClickWish = () => {
    setOpenWish(true);
  };

  const handleCloseWish = () => {
    setOpenWish(false);
  };

  const AddProductList = (type, product_id, price, wishFlag) => {
    postMethod("api/session/add_to_cart", {
      product_id: product_id,
      price: price,
      added_from: "customized",
      type: type,
    }).then((data) => {
      if (wishFlag != "true") {
        handleClickWish();
      }

      postMethod("api/session/wishlist", {
      }).then((dataD) => {
        setProductCount(dataD.data.length);
        getCustomisedProduct();
      });
    });
  };

  const setFilter = (value) => {
    if (value == "desc") {
      setShortFilters({
        ...short_filters,
        new: false,
        order: "desc",
        trial: false,
      });
    }
    if (value == "asc") {
      setShortFilters({
        ...short_filters,
        new: false,
        order: "asc",
        trial: false,
      });
    }
    if (value == "new") {
      setShortFilters({
        ...short_filters,
        new: true,
        order: "desc",
        trial: false,
      });
    }
    if (value == "trial") {
      setShortFilters({
        ...short_filters,
        new: false,
        order: "desc",
        trial: true,
      });
    }
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={load}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <CustomerHeader count={productCount} />
      <CustomerCategoryBanner />
      <Snackbar
        open={openWish}
        autoHideDuration={5000}
        onClose={handleCloseWish}
        message="Product added to wish list. Customer executive will contact you soon."
      />
      <div className="container-fluid my-0.5">
        <div className="row prosection  py-md-5">
          <div className="container">
            <div className="row">
              <div className="col-sm-3 botpad8 d-none d-lg-block d-md-block">
                <div
                  id="accordion"
                  className={`panel panel-primary behclick-panel accordion_panel ${classes.sidebarContainer}`}
                >
                  <div className="panel-heading">
                    <h3 className={classes.sidebarTitle}>Filters By </h3>
                  </div>
                  <div className="panel-body">
                    <div className="panel-heading ">
                      <Accordion
                        className={`${classes.accordionRoot} p-0`}
                        elevation={0}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography>Categories </Typography>
                        </AccordionSummary>
                        <AccordionDetails className="p-0">
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', padding: '4px 0 8px 0' }}>
                            {categorys &&
                              categorys.map((prop, i) => {
                                const isSelected = localStorage.getItem("category_id") == prop.category_id;
                                return (
                                  <label key={prop.category_id || i} style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, cursor: 'pointer', fontSize: '0.88rem' }}>
                                    <input
                                      type="radio"
                                      name="categoryname"
                                      checked={isSelected}
                                      onClick={() => {
                                        localStorage.setItem("jwl_category_banner_path", prop.banner_path || "");
                                        categorychange(prop.category_id, 0);
                                      }}
                                      style={{ margin: 0, cursor: 'pointer' }}
                                    />
                                    <span style={{ fontWeight: isSelected ? '700' : '400' }}>{prop.category_name}</span>
                                  </label>
                                );
                              })}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>

                    <div className={classes.priceSection}>
                      <div className={classes.priceTitle}>Price</div>
                      <InputRange
                        maxValue={priceRangeSet.max}
                        minValue={0}
                        value={priceRange}
                        onChange={changeRange}
                      />
                    </div>

                    {metals && metals.some(m => m.Metal && m.Metal.trim()) && (
                      <div className="panel-heading">
                        <Accordion className={classes.accordionRoot} elevation={0}>
                          <AccordionSummary
                            className={classes.accordionSummary}
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography className={classes.accordionTitle}>Metal</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '0 0 4px 0' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', width: '100%', paddingTop: 0 }}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="metal"
                                  checked={metal === ""}
                                  onChange={() => setMetal("")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>ALL</span>
                              </label>
                              {metals.map((prop, i) => (
                                <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                  <input
                                    type="radio"
                                    name="metal"
                                    checked={metal === prop.Metal}
                                    onChange={(e) => setMetal(e.target.checked ? prop.Metal : "")}
                                    style={{ margin: 0, cursor: 'pointer' }}
                                  />
                                  <span>{prop.Metal}</span>
                                </label>
                              ))}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}
                    <div className="panel-heading">
                      <Accordion className={classes.accordionRoot} elevation={0}>
                        <AccordionSummary
                          className={classes.accordionSummary}
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography className={classes.accordionTitle}>Material</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ padding: '0 0 4px 0' }}>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', width: '100%', paddingTop: 0 }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                              <input
                                type="radio"
                                name="material"
                                checked={material === ""}
                                onChange={() => setMaterial("")}
                                style={{ margin: 0, cursor: 'pointer' }}
                              />
                              <span>ALL</span>
                            </label>
                            {materials && materials.map((prop, i) => (
                              <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="material"
                                  checked={material === prop.material}
                                  onChange={(e) => setMaterial(e.target.checked ? prop.material : "")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>{prop.material}</span>
                              </label>
                            ))}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                    <div className="panel-heading">
                      <Accordion className={classes.accordionRoot} elevation={0}>
                        <AccordionSummary
                          className={classes.accordionSummary}
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography className={classes.accordionTitle}>Shop for</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ padding: '0 0 4px 0' }}>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', width: '100%', paddingTop: 0 }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                              <input
                                type="radio"
                                name="gender"
                                checked={gender === ""}
                                onChange={() => setGender("")}
                                style={{ margin: 0, cursor: 'pointer' }}
                              />
                              <span>ALL</span>
                            </label>
                            {genders && genders.map((prop, i) => (
                              <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="gender"
                                  checked={gender === prop.gender}
                                  onChange={(e) => setGender(e.target.checked ? prop.gender : "")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>{prop.gender}</span>
                              </label>
                            ))}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>

                    {weights && weights.some(w => w && String(w).trim()) && (
                      <div className="panel-heading">
                        <Accordion className={classes.accordionRoot} elevation={0}>
                          <AccordionSummary
                            className={classes.accordionSummary}
                            expandIcon={<ExpandMoreIcon />}
                          >
                            <Typography className={classes.accordionTitle}>Weight</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '0 0 4px 0' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', width: '100%', paddingTop: 0 }}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="weight"
                                  checked={weightFilter === ""}
                                  onChange={() => setWeightFilter("")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>ALL</span>
                              </label>
                              {weights.map((w, i) => (
                                <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                  <input
                                    type="radio"
                                    name="weight"
                                    checked={weightFilter === w}
                                    onChange={(e) => setWeightFilter(e.target.checked ? w : "")}
                                    style={{ margin: 0, cursor: 'pointer' }}
                                  />
                                  <span>{w}</span>
                                </label>
                              ))}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}

                    {colors && colors.some(c => c && String(c).trim()) && (
                      <div className="panel-heading">
                        <Accordion className={classes.accordionRoot} elevation={0}>
                          <AccordionSummary
                            className={classes.accordionSummary}
                            expandIcon={<ExpandMoreIcon />}
                          >
                            <Typography className={classes.accordionTitle}>Color</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '0 0 4px 0' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', width: '100%', paddingTop: 0 }}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                <input
                                  type="radio"
                                  name="color"
                                  checked={colorFilter === ""}
                                  onChange={() => setColorFilter("")}
                                  style={{ margin: 0, cursor: 'pointer' }}
                                />
                                <span>ALL</span>
                              </label>
                              {colors.map((c, i) => (
                                <label key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer', fontSize: '0.85rem' }}>
                                  <input
                                    type="radio"
                                    name="color"
                                    checked={colorFilter === c}
                                    onChange={(e) => setColorFilter(e.target.checked ? c : "")}
                                    style={{ margin: 0, cursor: 'pointer' }}
                                  />
                                  <span style={{
                                    display: 'inline-block',
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    backgroundColor: normalizeColor(c),
                                    border: '1px solid rgba(0,0,0,0.15)',
                                    flexShrink: 0
                                  }} />
                                  <span>{c}</span>
                                </label>
                              ))}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div
                id="sidebar"
                className="sidebar col-12 d-none d-lg-none d-md-none d-block"
              >
                {open ? null : (
                  <div className="container-fluid p-0">
                    <div className="row no-gutters">
                      <div className="col-6 lrpadd">
                        <button
                          type="button"
                          className="fltrbtn"
                          onClick={handleSortModal}
                        >
                          <i
                            className="fa fa-sort text-white"
                            aria-hidden="true"
                          ></i>{" "}
                          Sort By
                        </button>
                      </div>
                      <div className="col-6 lrpadd">
                        <button
                          type="button"
                          className="fltrbtn"
                          onClick={handleModal}
                        >
                          <i
                            className="fa fa-filter text-white"
                            aria-hidden="true"
                          ></i>{" "}
                          Filter By
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className="modal fade"
                  id="filterModal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog fltrmodal-dialog"
                    role="document"
                  >
                    <div className="modal-content fltrmodal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="fltrclose"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">
                            <i
                              className="fa fa-chevron-left"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </button>
                        <span>
                          <button type="button" className="fltrclr">
                            Clear All
                          </button>
                        </span>
                      </div>
                      <div className="modal-body fltrmodal-body">
                        <div className="tab">
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'price')"
                            id="defaultOpen"
                          >
                            Price
                          </button>
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'weight')"
                          >
                            Weight
                          </button>
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'material')"
                          >
                            Material
                          </button>
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'metal')"
                          >
                            Metal
                          </button>
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'size')"
                          >
                            Size/Lenth
                          </button>
                          <button
                            className="tablinks"
                            onclick="openFilter(event, 'shop')"
                          >
                            Shop For
                          </button>
                        </div>
                        <div id="price" className="tabcontent"></div>
                        <div id="weight" className="tabcontent">
                          <h3>Weight</h3>
                          <p>Paris is the capital of France.</p>
                        </div>
                        <div id="material" className="tabcontent">
                          <h3>Material</h3>
                          <p>Tokyo is the capital of Japan.</p>
                        </div>
                        <div id="metal" className="tabcontent">
                          <h3>Metal</h3>
                          <p>Tokyo is the capital of Japan.</p>
                        </div>
                        <div id="size" className="tabcontent">
                          <h3>Size/Lenth</h3>
                          <p>Tokyo is the capital of Japan.</p>
                        </div>
                        <div id="shop" className="tabcontent">
                          <h3>Shop For</h3>
                          <p>Tokyo is the capital of Japan.</p>
                        </div>
                        <div className="aplybutnbx">
                          <button className="btn allbtn" type="button">
                            APPLY FILTERS
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="modal fade"
                  id="sortModal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog fltrmodal-dialog"
                    role="document"
                  >
                    <div className="modal-content fltrmodal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="fltrclose"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">
                            <i
                              className="fa fa-chevron-left"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </button>

                        <span>
                          <button type="button" className="fltrclr">
                            Clear All
                          </button>
                        </span>
                      </div>
                      <div className="modal-body fltrmodal-body">
                        vmxcplvxz
                        <button className="aplybutn btn" type="button">
                          APPLY FILTERS
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-9 col-lg-9">
                <div className="row d-none d-lg-block d-md-block">
                  <div className="sortprobx">
                    <div className="form-group sortpro d-flex align-items-center">
                      <label className="w-50">Sort By</label>
                      <select
                        id="inputState"
                        className="form-control"
                        defaultValue="desc"
                        onChange={(e) => {
                          setFilter(e.target.value);
                        }}
                      >
                        <option value="desc">
                          Choose option
                        </option>
                        <option value="new">New</option>
                        <option value="asc">Price: Low to High</option>
                        <option value="desc"> Price: High to Low</option>
                        <option value="trial">Try at Home</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="clr"></div>
                <div className="clr"></div>
                <div className={classes.productGrid}>
                  {products && products.length > 0 && products.map((prop, i) => {
                    return (
                      <div
                        className={classes.productCard}
                        key={"product" + i}
                        onClick={() => RedirectToProduct(prop.product_id)}
                      >
                        <div className={classes.imageContainer}>
                          {prop.new == "true" ? (
                            <div className={`${classes.badge} ${classes.badgeNew}`}>New</div>
                          ) : null}
                          {prop.trial == true ? (
                            <div className={`${classes.badge} ${classes.badgeTrial}`}>
                              Trial
                            </div>
                          ) : null}
                          <span
                            className={
                              "ac-icon ac-icon-love-dark " +
                              classes.wishlistIcon +
                              " " +
                              (prop.wish == "true" ? "active" : "")
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              AddProductList(
                                "wish",
                                prop.product_id,
                                prop.price,
                                prop.wish
                              );
                            }}
                          ></span>
                          <img
                            className={classes.cardImage}
                            src={
                              prop?.isImageUrl
                                ? prop.image_path
                                : `${API_BASE_URL}Images/${prop?.image_path || ""}`
                            }
                            alt={prop.product_name}
                          />
                        </div>
                        <div className={classes.cardContent}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6 }}>
                            <div className={classes.productTitle}>{prop.product_name}</div>
                            {prop.color && (
                              <span title={prop.color} style={{
                                display: 'inline-block',
                                width: 14,
                                height: 14,
                                borderRadius: '50%',
                                backgroundColor: normalizeColor(prop.color),
                                border: '1px solid rgba(0,0,0,0.15)',
                                flexShrink: 0,
                              }} />
                            )}
                          </div>
                          {prop.size_length && (
                            <div className={classes.productSize}>
                              Size: <strong style={{ color: '#555' }}>{prop.size_length}</strong>
                            </div>
                          )}
                          {(localStorage.getItem("jwl_hide_price") == 'false' || localStorage.getItem("jwl_hide_price") == false) ? (
                            <div className={classes.priceContainer}>
                              {prop.discounted_price !== 0 &&
                                prop.discounted_price !== null &&
                                prop.discounted_price !== undefined ? (
                                <>
                                  <span className={classes.currentPrice}>₹ {prop.discounted_price}</span>
                                  <span className={classes.originalPrice}>₹ {prop.price}</span>
                                </>
                              ) : (
                                <span className={classes.currentPrice}>₹ {prop.price}</span>
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="clr"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="clr"></div>
      <CustomerBanner style={{ marginBottom: '40px' }} />
      <br />

      {/* Sort Modal */}
      <Dialog fullScreen open={sortOpen} TransitionComponent={Transition}>
        <DialogTitle id="form-dialog-title" className="p-0">
          <IconButton
            onClick={handleSortModal}
            aria-label="upload picture"
            component="span"
          >
            <i className="fas fa-arrow-left"></i>
            <span className="pl-3">Sort</span>
          </IconButton>
        </DialogTitle>
        <DialogContent className="p-3">

          <div
            className={
              "filterOption  mb-4 " + (sortObj.lowtohigh ? "active" : "")
            }
            onClick={() => setSortObj({ ...sortObj, new: false, hightolow: false, lowtohigh: true, new: false, tryathome: false })}
          >
            <i className={"fas fa-long-arrow-alt-up"}></i>
            <span>Lowest to Highest</span>
          </div>
          <div
            className={
              "filterOption  mb-4 " + (sortObj.hightolow ? "active" : "")
            }
            onClick={() => setSortObj({ ...sortObj, new: false, hightolow: true, lowtohigh: false, new: false, tryathome: false })}
          >
            <i className={"fas fa-long-arrow-alt-down"}></i>
            <span>Highest to Lowest</span>
          </div>

          <div
            className={
              "filterOption  mb-4 " + (sortObj.new ? "active" : "")
            }
            onClick={() => setSortObj({ ...sortObj, new: false, hightolow: false, lowtohigh: false, new: true, tryathome: false })}
          >
            <i className={"fa fa-star-o"}></i>
            <span>New</span>
          </div>
          <div
            className={
              "filterOption  mb-4 " + (sortObj.tryathome ? "active" : "")
            }
            onClick={() => setSortObj({ ...sortObj, new: false, hightolow: false, lowtohigh: false, new: false, tryathome: true })}
          >
            <i className={"fa fa-home"}></i>
            <span>Try at Home</span>
          </div>


        </DialogContent>
        <DialogActions>
          <button
            className="fltrbtn btm w-100 py-3"
            onClick={() => applyShorting()}
          >
            Apply Sort
          </button>
        </DialogActions>
      </Dialog>

      {/* Filter Modal */}
      <Dialog fullScreen open={open} TransitionComponent={Transition}>
        <DialogTitle id="form-dialog-title" className="p-0">
          <IconButton
            onClick={handleModal}
            aria-label="upload picture"
            component="span"
          >
            <i className="fas fa-arrow-left"></i>
            <span className="pl-3">Filters</span>
          </IconButton>
        </DialogTitle>
        <DialogContent className="d-flex p-0">
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={Tabvalue}
            className={classes.tabs}
            onChange={handleChange}
            aria-label="Vertical tabs example"
          >
            <Tab label="Price" {...a11yProps(0)} />
            {metals && metals.some(m => m.Metal && m.Metal.trim()) && <Tab label="Metal" {...a11yProps(1)} />}
            {materials && materials.some(m => m.material && m.material.trim()) && <Tab label="Material" {...a11yProps(2)} />}
            {genders && genders.some(g => g.gender && g.gender.trim()) && <Tab label="Shop For" {...a11yProps(3)} />}
            {weights && weights.some(w => w && String(w).trim()) && <Tab label="Weight" {...a11yProps(4)} />}
            {colors && colors.some(c => c && String(c).trim()) && <Tab label="Color" {...a11yProps(5)} />}
          </Tabs>
          <div
            className={
              (Tabvalue != "0" ? "d-none" : "") + " bg-light container pt-3"
            }
          >
            <div className="mt-5">
              <InputRange
                maxValue={priceRangeSet.max}
                minValue={0}
                value={priceRange}
                onChange={changeRange}
              />
            </div>
          </div>
          {metals && metals.some(m => m.Metal && m.Metal.trim()) && (
            <div
              className={
                (Tabvalue != "1" ? "d-none" : "") + " bg-light container pt-3"
              }
            >
              {metals &&
                metals.map((prop, i) => {
                  return (
                    <div
                      className={
                        "filterOption mb-4 " +
                        (prop.Metal === metal ? "active" : "")
                      }
                      onClick={() => setMetal(prop.Metal)}
                    >
                      <i className="fas fa-check"></i>
                      <span>{prop.Metal}</span>
                    </div>
                  );
                })}
              <div
                className={
                  "filterOption  mb-4 " +
                  (metal === '' ? "active" : "")
                }
                onClick={() => setMetal('')}
              >
                <i className="fas fa-check"></i>
                <span>All</span>
              </div>
            </div>
          )}
          <div
            className={
              (Tabvalue != "2" ? "d-none" : "") + " bg-light container pt-3"
            }
          >
            {materials &&
              materials.map((prop, i) => {
                return (
                  <div
                    className={
                      "filterOption  mb-4 " +
                      (prop.material === material ? "active" : "")
                    }
                    onClick={() => setMaterial(prop.material)}
                  >
                    <i className="fas fa-check"></i>
                    <span>{prop.material}</span>
                  </div>
                );
              })}
            <div
              className={
                "filterOption  mb-4 " +
                (material === '' ? "active" : "")
              }
              onClick={() => setMaterial('')}
            >
              <i className="fas fa-check"></i>
              <span>All</span>
            </div>
          </div>
          <div
            className={
              (Tabvalue != "3" ? "d-none" : "") + " bg-light container pt-3"
            }
          >
            {genders &&
              genders.map((prop, i) => {
                return (
                  <div
                    className={
                      "filterOption mb-4 " +
                      (prop.gender === gender ? "active" : "")
                    }
                    onClick={() => setGender(prop.gender)}
                  >
                    <i className="fas fa-check"></i>
                    <span>{prop.gender}</span>
                  </div>
                );
              })}
            <div
              className={
                "filterOption  mb-4 " +
                (gender === '' ? "active" : "")
              }
              onClick={() => setGender('')}
            >
              <i className="fas fa-check"></i>
              <span>All</span>
            </div>
          </div>
          {weights && weights.some(w => w && String(w).trim()) && (
            <div
              className={
                (Tabvalue != 4 ? "d-none" : "") + " bg-light container pt-3"
              }
            >
              {weights.map((w, i) => (
                <div
                  key={i}
                  className={
                    "filterOption mb-4 " +
                    (w === weightFilter ? "active" : "")
                  }
                  onClick={() => setWeightFilter(w === weightFilter ? "" : w)}
                >
                  <i className="fas fa-check"></i>
                  <span>{w}</span>
                </div>
              ))}
              <div
                className={
                  "filterOption mb-4 " +
                  (weightFilter === '' ? "active" : "")
                }
                onClick={() => setWeightFilter('')}
              >
                <i className="fas fa-check"></i>
                <span>All</span>
              </div>
            </div>
          )}
          {colors && colors.some(c => c && String(c).trim()) && (
            <div
              className={
                (Tabvalue != 5 ? "d-none" : "") + " bg-light container pt-3"
              }
            >
              {colors.map((c, i) => (
                <div
                  key={i}
                  className={
                    "filterOption mb-4 " +
                    (c === colorFilter ? "active" : "")
                  }
                  onClick={() => setColorFilter(c === colorFilter ? "" : c)}
                >
                  <i className="fas fa-check"></i>
                  <span style={{
                    display: 'inline-block',
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: normalizeColor(c),
                    marginRight: 6,
                    border: '1px solid rgba(0,0,0,0.15)'
                  }} />
                  <span>{c}</span>
                </div>
              ))}
              <div
                className={
                  "filterOption mb-4 " +
                  (colorFilter === '' ? "active" : "")
                }
                onClick={() => setColorFilter('')}
              >
                <i className="fas fa-check"></i>
                <span>All</span>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <button
            className="fltrbtn btm w-100 py-3"
            onClick={() => setOpen(false)}
          >
            Apply Filter
          </button>
        </DialogActions>
      </Dialog>

      <CustomerFooter />
    </>
  );
};

export default CustomerProducts;
